import { OidcUser } from '../types/oidcUser'

export const getOrganizationId = (user: OidcUser | null | undefined) => user?.profile?.organization?.[0]?.id || ''
